import React from 'react';
import { FaEnvelope } from 'react-icons/fa'; // Importer les icônes nécessaires

// ButtonEdit avec une icône d'édition
const ButtonMail = ({ onClick, className = '', hoverLabel = 'Envoyer Mail de Relance'  }) => {
  return (
    <button
      onClick={onClick}
      aria-label={hoverLabel}
      title={hoverLabel} 
      className={`w-8 h-8 bg-orange-500 text-white rounded-md shadow-sm transition duration-300 ease-in-out hover:bg-orange-700 flex items-center justify-center ${className}`}
    >
      <FaEnvelope className='text-[12px]'/>
    </button>
  );
};


export default ButtonMail;
